import { doc, getDoc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../firebase";

function getFleetDocRef(fleetId) {
  return doc(db, "fleets", fleetId);
}

export async function getFleetDetails(fleetId) {
  if (!fleetId) return null;
  const snapshot = await getDoc(getFleetDocRef(fleetId));
  if (!snapshot.exists()) return null;
  return { id: snapshot.id, ...snapshot.data() };
}

export async function updateFleetDetails(fleetId, patch) {
  if (!fleetId) throw new Error("Missing fleetId");
  await setDoc(getFleetDocRef(fleetId), patch, { merge: true });
}

export function subscribeFleetDetails(fleetId, onData, onError) {
  if (!fleetId) return () => {};
  return onSnapshot(
    getFleetDocRef(fleetId),
    (snapshot) => {
      if (!snapshot.exists()) {
        onData?.(null);
        return;
      }
      onData?.({ id: snapshot.id, ...snapshot.data() });
    },
    (error) => {
      onError?.(error);
    }
  );
}
